import { FieldDef, GroupDef, GuiDef, ValidatorDef, TabDefinition, CollapsableDef } from '@/objects/gui';
import { Participant } from '@/objects/generated';
import { markRaw, computed } from 'vue';
import { InputNullableDateTime, InputDateTime, DateComp, InputText, ValidatedText } from '@/components';
import { type DateType } from '@/utilities/dateutils';
import type { SelectLine, SelectLineValueType } from '@/objects/SelectLine';

export class ParticipantGuiDef extends GuiDef<Participant> {
    constructor() {
        super('Participant');

        const Firstname = new FieldDef<Participant>();
        Firstname.Name = 'Firstname';
        Firstname.FieldName = 'Firstname';
        Firstname.DefinedFor = 'Both';
        Firstname.TranslationKey = 'participant.firstname';
        Firstname.Editable = true;
        Firstname.Filterable = false;
        Firstname.Sortable = true;
        Firstname.CssClasses = '';
        Firstname.value = (participant) => participant.Firstname;
        Firstname.setValue = (participant, value) => (participant.Firstname = value);
        Firstname.Validator = null;
        Firstname.SortDirection = undefined;
        Firstname.cellClassRules = undefined;
        Firstname.MinWidth = undefined;
        Firstname.MaxWidth = undefined;
        Firstname.Tooltip = null;
        this.Fields.push(Firstname);

        const Surname = new FieldDef<Participant>();
        Surname.Name = 'Surname';
        Surname.FieldName = 'Surname';
        Surname.DefinedFor = 'Both';
        Surname.TranslationKey = 'participant.surname';
        Surname.Editable = true;
        Surname.Filterable = false;
        Surname.Sortable = true;
        Surname.CssClasses = '';
        Surname.value = (participant) => participant.Surname;
        Surname.setValue = (participant, value) => (participant.Surname = value);
        Surname.Validator = null;
        Surname.SortDirection = undefined;
        Surname.cellClassRules = undefined;
        Surname.MinWidth = undefined;
        Surname.MaxWidth = undefined;
        Surname.Tooltip = null;
        this.Fields.push(Surname);

        const Birthday = new FieldDef<Participant>();
        Birthday.Name = 'Birthday';
        Birthday.FieldName = 'Birthday';
        Birthday.DefinedFor = 'Both';
        Birthday.TranslationKey = 'participant.birthday';
        Birthday.Editable = true;
        Birthday.Filterable = true;
        Birthday.Sortable = true;
        Birthday.CssClasses = '';
        Birthday.value = (participant) => participant.Birthday;
        Birthday.setValue = (participant, value) => (participant.Birthday = value);
        Birthday.DetailEditor = markRaw(InputNullableDateTime);
        Birthday.DetailEditorProps = { format: 'DATE' as DateType };
        Birthday.CellEditor = markRaw(InputDateTime);
        Birthday.CellEditorProps = { format: 'DATE' as DateType };
        Birthday.CellRenderer = markRaw(DateComp);
        Birthday.CellRendererProps = { format: 'DATE' as DateType };
        Birthday.Validator = null;
        Birthday.SortDirection = undefined;
        Birthday.cellClassRules = undefined;
        Birthday.MinWidth = 135;
        Birthday.MaxWidth = 135;
        Birthday.Tooltip = null;
        this.Fields.push(Birthday);

        const City = new FieldDef<Participant>();
        City.Name = 'City';
        City.FieldName = 'City';
        City.DefinedFor = 'Both';
        City.TranslationKey = 'participant.city';
        City.Editable = true;
        City.Filterable = true;
        City.Sortable = true;
        City.CssClasses = '';
        City.value = (participant) => participant.City;
        City.setValue = (participant, value) => (participant.City = value);
        City.DetailEditor = markRaw(InputText);
        City.DetailEditorProps = {};
        City.CellEditor = markRaw(InputText);
        City.CellEditorProps = {};
        City.CellRenderer = markRaw(ValidatedText);
        City.CellRendererProps = {};
        City.Validator = null;
        City.SortDirection = undefined;
        City.cellClassRules = undefined;
        City.MinWidth = undefined;
        City.MaxWidth = undefined;
        City.Tooltip = null;
        this.Fields.push(City);
    }

    public async LoadDependencies() {}
}
